import './App.css';
import { Footer } from './components/atoms/Footer';
import { Header } from './components/atoms/Header';
import { BlogDetail } from './pages/blog/BlogDetail';
import Home from './pages/home/Home';
import { MainRouter } from './routes/MainRouter';

function App() {

  return (
    <>
      <div className="fixed bg-white dark:bg-zinc-800/90 flex justify-center sm:px-8">
        <div className="flex w-full max-w-7xl lg:px-8">
          <div className="w-full bg-white ring-1 ring-zinc-100 dark:bg-zinc-800 dark:ring-zinc-300/20" />
        </div>
      </div>
      <div className="relative dark:bg-zinc-800">
        <main>       
          <MainRouter />
          <Footer/>
        </main>
      </div>

    </>
  );
}

export default App;
